module.exports = __webpack_public_path__ + "img/timeLine-two-hover.b3993328.png";